import { PointId } from '@shared/models/point';

export enum TileDataSource {
  Device = 'device',
  Formula = 'formula',
}

export interface PointSelection {
  pointId: PointId;
  pointName: string;
}
